import { supabase } from '../lib/supabase';

export interface DeliveryOption {
  id: string;
  carrier: 'DHL' | 'Hermes' | 'DPD';
  name: string;
  country: string;
  max_weight_kg: number | null;
  max_length_cm: number | null;
  max_width_cm: number | null;
  max_height_cm: number | null;
  price_eur: number | null;
  tracking: boolean | null;
  insurance_eur: number | null;
}

export class DeliveryOptionsService {
  static async getAll(country: string = 'DE'): Promise<DeliveryOption[]> {
    const { data, error } = await supabase
      .from('delivery_options')
      .select('*')
      .eq('country', country)
      .order('carrier', { ascending: true })
      .order('price_eur', { ascending: true, nullsFirst: true });

    if (error) {
      console.error('Failed to fetch delivery options:', error);
      throw new Error(`Failed to fetch delivery options: ${error.message}`);
    }
    return data || [];
  }

  static async saveProductSelections(
    productId: string,
    deliveryOptionIds: string[],
    priceOverrides?: Record<string, number | undefined>
  ): Promise<void> {
    if (!deliveryOptionIds || deliveryOptionIds.length === 0) return;

    const rows = deliveryOptionIds.map((id) => ({
      product_id: productId,
      delivery_option_id: id,
      price_override_eur: priceOverrides?.[id] ?? null,
    }));

    const { error } = await supabase
      .from('product_delivery_options')
      .insert(rows);

    if (error) {
      console.error('Failed to save product delivery options:', error);
      throw new Error(`Failed to save product delivery options: ${error.message}`);
    }
  }
}


